import { render, staticRenderFns } from "./PrepaymentSettingDialog.vue?vue&type=template&id=5b8f7801&"
import script from "./PrepaymentSettingDialog.vue?vue&type=script&lang=js&"
export * from "./PrepaymentSettingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports